import { ActivePassiveItemService } from "./../../../services/catalogs/ActivePassiveItemService";
import React from "react";
import { ContractDetail } from "../../../components/Pages/Catalogs/Contract/ContractDetail";
import { CatalogService } from "../../../services/catalogs/CatalogService";
import { CreateContractDto } from "../../../dtos/catalogs/contract/CreateContractDto";
import { IAppEntity } from "../../entities";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { ACtivePassiveItemDetail } from "../../../components/Pages/Catalogs/ActivePassiveItem/ActivePassiveItemDetail";
import { CreateActivePassiveItemDto } from "../../../dtos/catalogs/ActivePassiveItem/CreateActivePassiveItemDto";
import { NFLookupActivePassiveItem } from "../../../components/Shared/NewForms/NFLookupActivePassiveItem";
import ActivePassiveItemList from "../../../components/Pages/Catalogs/ActivePassiveItem/ActivePassiveItemList";

export const ActivePassiveItem: IAppEntity = {
  entityType: "catalog",
  title: "Active Passive Item",
  pluralTitle: "Active Passive Item",
  apiUrl: "ActivePassiveItems",
  apiEnum: ReferenceTypes.CatalogActivePassiveItem,
  getDetailViewComponent: (
    model: any,
    modelUpdatedEvent: (model: any) => void
  ) =>
    React.createElement(ACtivePassiveItemDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(ActivePassiveItemList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupActivePassiveItem, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService: () => new ActivePassiveItemService("ActivePassiveItems"),
  getEmptyModel: () => {
    const model: CreateActivePassiveItemDto = {
      name: "",
      description: "",
      createdDate: new Date(),
      itemTypeActivePassiveItem: 0,
      vendorCustomerId: "",
      uniqueCode:""
    };
    return model;
  },
};
